<template lang="pug">
  div.container
    el-table(
      :data="schema.values",
      stripe
    )
      el-table-column(
        :formatter="formattedMarcos",
        label="Marcos"
      )
      el-table-column(
        label='Distância (m)',
        prop='distancia'
      )
      el-table-column(
        label='Azimutes',
        prop='azimute',
      )
      el-table-column(
        prop='confinante',
        label='Confinantes'
      )
</template>

<script>
import { abstractField } from 'vue-form-generator'

export default {

  mixins: [ abstractField ],

  methods: {
    formattedMarcos (prop) {
      return (prop.marcoInicial && prop.marcoFinal) ? prop.marcoInicial + '/' + prop.marcoFinal : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
  .label {
    font-family: sans-serif;
    font-size: 14px;
    color: green;
    margin: 250px;
  }
  .margin-input {
    margin-top: 30px;
    margin-bottom: 21px;
  }
  .container {
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppListagemLimites.vue